import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { Shield, Lock, FileText, Scale, ArrowRight, Info } from 'lucide-react';
export function TransparencySection() {
  return <SectionWrapper background="white" id="transparency" data-id="element-240">
      <div className="flex flex-col md:flex-row md:items-center justify-between mb-10" data-id="element-241">
        <div data-id="element-242">
          <h2 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-243">
            Trust &amp; Transparency
          </h2>
          <p className="text-slate-600 text-sm" data-id="element-244">
            How we maintain editorial integrity alongside our business
            operations.
          </p>
        </div>
        <a href="#" className="hidden md:flex items-center text-sm font-medium text-teal-700 hover:text-teal-800 mt-4 md:mt-0" data-id="element-245">
          Read Transparency Policy <ArrowRight className="ml-1 w-4 h-4" data-id="element-246" />
        </a>
      </div>

      <div className="bg-slate-50 border border-slate-200 rounded-lg p-6 mb-10 flex gap-4" data-id="element-247">
        <Info className="w-5 h-5 text-teal-700 flex-shrink-0 mt-0.5" data-id="element-248" />
        <div data-id="element-249">
          <h3 className="font-bold text-slate-900 text-sm mb-1" data-id="element-250">
            How We Operate
          </h3>
          <p className="text-sm text-slate-600 leading-relaxed" data-id="element-251">
            D2D Guides is operated by a team that also provides consulting and
            recruiting services in the D2D industry. Our editorial evaluations
            are produced independently using a standardized framework and are
            never influenced by service relationships. When a guide covers a
            company or tool connected to our services, that relationship is
            disclosed at the top of the guide.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-252">
        {[{
        icon: Shield,
        title: 'Editorial Firewall',
        desc: 'Evaluations are produced independently from our consulting and recruiting operations.'
      }, {
        icon: Lock,
        title: 'No Paid Rankings',
        desc: 'Evaluations cannot be bought or influenced. Not by clients, not by anyone.'
      }, {
        icon: FileText,
        title: 'Full Disclosure',
        desc: 'Every guide flags if the subject has a business relationship with our team.'
      }, {
        icon: Scale,
        title: 'Right to Respond',
        desc: 'Companies can correct facts, but not edit evaluations or scores.'
      }].map((badge, i) => <div key={i} className="flex flex-col items-center text-center p-6 bg-white border border-slate-200 rounded-lg hover:border-teal-200 transition-colors" data-id="element-253">
            <div className="w-12 h-12 bg-teal-50 rounded-full flex items-center justify-center mb-4 text-teal-700" data-id="element-254">
              <badge.icon size={24} data-id="element-255" />
            </div>
            <h3 className="font-bold text-slate-900 text-sm mb-2" data-id="element-256">
              {badge.title}
            </h3>
            <p className="text-xs text-slate-500 leading-relaxed" data-id="element-257">
              {badge.desc}
            </p>
          </div>)}
      </div>

      <div className="mt-8 text-center md:hidden" data-id="element-258">
        <a href="#" className="inline-flex items-center text-sm font-medium text-teal-700 hover:text-teal-800" data-id="element-259">
          Read Transparency Policy <ArrowRight className="ml-1 w-4 h-4" data-id="element-260" />
        </a>
      </div>
    </SectionWrapper>;
}